// extracted by mini-css-extract-plugin
export default {"donate_container":"Donate_donate_container__InwZ2","donate_button":"Donate_donate_button__A+RmU"};